import { OOS_RECOVERY_OPTIONS, FLOW_TYPES, } from '../../../constants/out-of-stock';
var OOS_RECOVERY_OPTION_KEYS = Object.keys(OOS_RECOVERY_OPTIONS);
export var getFlowTypeValue = function (currentDrawer, currentFlow) {
    if (OOS_RECOVERY_OPTION_KEYS.includes(currentDrawer)) {
        return FLOW_TYPES.BOPIS_OOS_RECOVERY;
    }
    return currentFlow;
};
